import axios from "axios";
import userAuthenticationConfig from "./userAuthenticationConfig";

export const check2FA = (user, twofa) => {
  return axios.post("/api/check-twofa", { user: user, twofa: twofa }, userAuthenticationConfig()).catch(error => {
    return { error: error.response.data.message };
  });
};